import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  productTypeContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(1.5),
  },
  sectionHeading: {
    fontFamily: theme.typography.fontFamily,
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '24px',
    letterSpacing: '0.15px',
    color: theme.palette.labraText.primary,
  },
  sectionText: {
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '16px',
    letterSpacing: '0.25px',
    color: theme.palette.labraText.description,
    fontFamily: theme.typography.fontFamily,
    textAlign: 'left',
  },
  productNameWrapper: {
    backgroundColor: theme.palette.text.white,
    padding: theme.spacing(2, 5),
    borderRadius: theme.spacing(1),
  },
  textContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(0.5),
  },
}))
